import { useContext, useState } from 'react';
import { redeemReferralReward } from '../services';
import { toast } from 'react-toastify';
import { UserContext } from '../contexts/user.context';
import { ReferralMembershipRewardModel, UserProviderValue } from '../models';

export function useMembershipReward(membershipId: string) {
   const { userReferrals, setUserReferrals } = useContext<UserProviderValue>(UserContext);
   const [isLoading, setIsLoading] = useState(false);

   const [activateOpen, setActivateOpen] = useState(false);

   const redeemFreeMonth = async () => {
      setIsLoading(true);
      const response = await redeemReferralReward(membershipId);
      if (response.error || !response.data) {
         toast.error(response.error?.message || 'You are not eligible for this reward');
         setIsLoading(false);
         return;
      }

      toast.success('Membership activated successfully');

      setIsLoading(false);
      setActivateOpen(false);
      if (!userReferrals.membershipRewards) return;
      setUserReferrals({
         ...userReferrals,
         membershipRewards: userReferrals?.membershipRewards?.map((reward) => {
            if (reward.membership.id === membershipId) {
               return {
                  ...reward,
                  redeemed: true,
                  allowRedeem: false,
               } as ReferralMembershipRewardModel;
            }
            return reward;
         }),
      });
   };

   return {
      isLoading,
      redeemFreeMonth,
      activateOpen,
      setActivateOpen,
   };
}
